import { Link } from "react-router-dom";
import { COMPETITORS, USE_CASES, SITE } from "@/lib/seoData";

export default function MarketingFooter() {
  return (
    <footer className="border-t border-zinc-200 bg-white mt-16">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="text-sm font-semibold text-zinc-900">BreakItDown</div>
          <p className="text-xs text-zinc-500 mt-2 leading-relaxed">
            AI-powered task breakdown. Free forever.
          </p>
        </div>

        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-500 mb-3">Product</div>
          <ul className="space-y-2 text-xs">
            <li><Link to="/" className="text-zinc-700 hover:text-zinc-900">Home</Link></li>
            <li><Link to="/pricing" className="text-zinc-700 hover:text-zinc-900">Pricing</Link></li>
            <li><Link to="/changelog" className="text-zinc-700 hover:text-zinc-900">Changelog</Link></li>
            <li><Link to="/about" className="text-zinc-700 hover:text-zinc-900">About</Link></li>
            <li><Link to="/help" className="text-zinc-700 hover:text-zinc-900">Help</Link></li>
            <li><Link to="/blog" className="text-zinc-700 hover:text-zinc-900">Blog</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-500 mb-3">Compare</div>
          <ul className="space-y-2 text-xs">
            {COMPETITORS.map((c) => (
              <li key={c.slug}>
                <Link to={`/compare/${c.slug}`} className="text-zinc-700 hover:text-zinc-900">
                  vs {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-2">
          <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-500 mb-3">Use cases</div>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
            {USE_CASES.filter((u) => u.slug !== "adhd-productivity").map((u) => (
              <li key={u.slug}>
                <Link to={`/use-cases/${u.slug}`} className="text-zinc-700 hover:text-zinc-900">
                  {u.h1.split(":")[0].split(" — ")[0]}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-200 px-6 md:px-10 py-6 max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
        <span>© {new Date().getFullYear()} {SITE.name} · Built for focused minds.</span>
        <a
          href={SITE.founder.url}
          target="_blank"
          rel="noopener noreferrer"
          className="uppercase tracking-[0.15em] hover:text-[#002FA7]"
        >
          A <span className="font-semibold text-zinc-900">{SITE.founder.name}</span> app ↗
        </a>
      </div>
    </footer>
  );
}
